<template>
  <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
</template>

<script>
import {StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "@/views/online-factor/datatable/columns_formats";
import actionsColumn from "@/views/online-factor/components/actions_column_customer_formats.vue";

export default {
  name: "format-without-manage",
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    datatableProps() {
      return {
        id: 'formatWithoutManageAccess',
        data: {
          type: 'remote',
          source: {
            read: {
              url: StarShopApiUrl.path('customer/format'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function(res) {
                return res.data.data;
              },
              params: this.query,
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn
      };
    }
  },
}
</script>

<style scoped>

</style>